import { z } from 'zod'

import { FormError } from '@/utils/localisation'

export const PasswordFormSchema = z
  .object({
    currentPassword: z.string(),
    newPassword: z.string().min(8, FormError.MIN_PASSWORD).max(50, FormError.MAX_PASSWORD),
    newPassword2: z.string().min(8, FormError.MIN_PASSWORD).max(50, FormError.MAX_PASSWORD),
  })
  .superRefine(({ newPassword, newPassword2 }, ctx) => {
    if (newPassword !== newPassword2) {
      ctx.addIssue({
        code: 'custom',
        path: ['newPassword2'],
      })
    }
  })

export type PasswordFormSchemaType = z.infer<typeof PasswordFormSchema>
